import { __exports as urlClient } from './_virtual-urlClient.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import { __require as requireWeb_domCollections_iterator } from './node_modules-core-js-modules-web.dom-collections.iterator.js';
import { __require as requireDefineProperty } from './node_modules-@babel-runtime-helpers-defineProperty.js';
import { __require as requireLogger } from './vp-js-token-engine-build-infrastructure-logger.js';

var hasRequiredUrlClient;

function requireUrlClient () {
	if (hasRequiredUrlClient) return urlClient;
	hasRequiredUrlClient = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(urlClient, "__esModule", {
	  value: true
	});
	urlClient.UrlClient = void 0;
	requireWeb_domCollections_iterator();
	var _defineProperty2 = _interopRequireDefault(requireDefineProperty());
	var _logger = requireLogger();
	class UrlClient {
	  constructor() {
	    (0, _defineProperty2.default)(this, "urlCache", void 0);
	    (0, _defineProperty2.default)(this, "baseUrl", void 0);
	    this.urlCache = new Map();
	    this.baseUrl = 'https://url.prod.merch.vpsvc.com/v3';
	  }
	  async getPageSlug(pageId, culture, tenant) {
	    const cachedResult = this.urlCache.get(pageId);
	    if (cachedResult !== undefined) {
	      return cachedResult;
	    }
	    const url = "".concat(this.baseUrl, "/url/").concat(tenant, "/").concat(culture, "/").concat(pageId, "?requestor=TokenEngine");
	    let responseUrl;
	    try {
	      const response = await fetch(url);
	      const data = await response.json();
	      responseUrl = data.url;
	    } catch (error) {
	      responseUrl = '#';
	      _logger.logger.error("The request for tenant ".concat(tenant, " and ").concat(culture, " to url: ").concat(url, ". Returned error ").concat(error.stack), {
	        contextData: {
	          stack: error.stack,
	          culture,
	          tenant
	        }
	      });
	    }
	    this.urlCache.set(pageId, responseUrl);
	    return responseUrl;
	  }
	  async fillUrlCache(culture, tenant) {
	    const urlTypes = await this.getUrlTypes(tenant);
	    const urlPromises = [];
	    for (const urlType of urlTypes) {
	      urlPromises.push(this.getUrls(tenant, culture, urlType));
	    }
	    const urlsResponse = await Promise.all(urlPromises);
	    const urls = new Map();
	    for (const response of urlsResponse) {
	      if (response) {
	        Object.keys(response).forEach(key => {
	          urls.set(key, response[key].url);
	        });
	      }
	    }
	    this.urlCache = urls;
	  }
	  async getUrlTypes(tenant) {
	    const typesUrl = "".concat(this.baseUrl, "/types/").concat(tenant, "?requestor=TokenEngine");
	    const response = await fetch(typesUrl);
	    return response && response.json();
	  }
	  async getUrls(tenant, culture, urltype) {
	    const urlSvcBatch = "".concat(this.baseUrl, "/all/").concat(tenant, "/").concat(culture, "?requestor=TokenEngine&pageType=").concat(urltype);
	    try {
	      const response = await fetch(urlSvcBatch);
	      return response.json();
	    } catch (e) {
	      return undefined;
	    }
	  }
	}
	urlClient.UrlClient = UrlClient;
	
	return urlClient;
}

export { requireUrlClient as __require };
//# sourceMappingURL=vp-js-token-engine-build-services-urlClient.js.map
